import * as React from "react";
import type { SVGProps } from "react";
const SvgLuggage02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M7.8 19.2V8.4m7.8 10.8V8.4m-7.2-.6V5.4a1.2 1.2 0 0 1 1.2-1.2h4.2A1.2 1.2 0 0 1 15 5.4v2.4m-10.2 12h14.4a2.4 2.4 0 0 0 2.4-2.4v-7.2a2.4 2.4 0 0 0-2.4-2.4H4.8a2.4 2.4 0 0 0-2.4 2.4v7.2a2.4 2.4 0 0 0 2.4 2.4Z"
    />
  </svg>
);
export default SvgLuggage02;
